import React from 'react';
import InfoIcon from './InfoIcon';

const badgeConfig = {
  popular: { text: 'Most Popular!', from: '#6EC9AB', to: '#00A3DA' },
  limited: { text: 'Limited Stock', from: '#C01F85', to: '#009CFF' },
  lowCost: { text: 'Low Cost', from: '#6EC9AB', to: '#00A3DA' },
  // …add more types here if you need
};

export default function BottomCard({ item, quantity, price, showProductsOneRow, currencyStore, productTitle, onAdd, onRemove, onBlur, currAmount }) {
  return (
    <div className="bg-white rounded-lg flex flex-col items-center p-1 md:p-2 mb-2" tabIndex={0} onBlur={onBlur}>
      {/* header */}

      {/* body */}
      <div className="w-full flex flex-col">
        <div className="flex items-center w-full justify-center">
          <img
            src={item.image_link}
            alt={item.name}
            className={`${showProductsOneRow ? '' : 'hidden-'} md:block w-16 h-16 object-cover mr-2 rounded shadow-md`}
          />

          <div className="w-full flex flex-col">
            <div className="flex items-center w-full justify-between">
              <h3 className="font-brandingBold text-[#00A3DA] text-left">{item.name}</h3>

              <InfoIcon className="w-5 h-5 flex-shrink-0 ml-2" />
            </div>

            {/* price + qty controls */}
            <div className={`flex items-center justify-between w-full ${'mt-2 md:mt-4'}`}>
              {/* price */}
              <div className="flex items-center bg-[#E9F7FF] rounded px-2 py-1">
                <span className="font-brandingBold text-[#00A3DA] text-[17px] px-2 py-1 leading-[12px] text-center">
                  {currAmount(currencyStore, price)}
                </span>
              </div>

              {/* “–  qty  +” */}
              <div className="flex items-center bg-[#E9F7FF] p-1 rounded min-w-[107px] justify-between">
                <button
                  className="bg-[#01A7E1] text-white text-2xl font-bold py-1.5 px-1.5 rounded leading-3"
                  onClick={onRemove}
                  disabled={quantity === 0}
                >
                  –
                </button>
                <span className="text-[#00A3DA] text-[17px] px-2">{quantity}</span>
                <button className="bg-[#01A7E1] text-white text-2xl font-bold py-1.5 px-1.5 rounded leading-3" onClick={onAdd}>
                  +
                </button>
              </div>

              {/* Add button */}
              <button className="bg-pink text-white ml-3 px-2 py-1 rounded-lg min-w-[64px]" onClick={onAdd}>
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
